import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState, FunctionComponent } from 'react';
import { FixedContentPortal, FixedContentPortalType } from '../../fixedContent/FixedContentPortal/FixedContentPortal';
import { useEventCallback } from '../../hooks/useEventCallback';
import { useNotificationManager } from '../../hooks/useNotificationManager';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { NotificationCard, NotificationCardProps } from '../NotificationCard/NotificationCard';
import styles from './NotificationContainer.module.css';
export type NotificationContainerProps = PropsWithoutChildren<Record<never, never>>;
export const NotificationContainer: FunctionComponent<NotificationContainerProps> = React.memo(props => {
  const $ = _c(18);
  prepareProps({
    props,
    ignoreChildren: true
  });
  const notificationManager = useNotificationManager();
  let t0;
  if ($[0] !== notificationManager) {
    t0 = notificationManager.getNotifications();
    $[0] = notificationManager;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [notifications, setNotifications] = useState(t0);
  let t1;
  let t2;
  if ($[2] !== notificationManager) {
    t1 = () => {
      const disposable = notificationManager.bindNotifications(setNotifications);
      return () => disposable.dispose();
    };
    t2 = [notificationManager, setNotifications];
    $[2] = notificationManager;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== notificationManager) {
    t3 = notification => {
      notificationManager.hide(notification.id);
    };
    $[5] = notificationManager;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleNotificationCloseButtonClick = useEventCallback(t3);
  let t4;
  if ($[7] !== notificationManager) {
    t4 = notification_0 => {
      notificationManager.remove(notification_0.id);
    };
    $[7] = notificationManager;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleNotificationHidden = useEventCallback(t4);
  let t5;
  if ($[9] !== handleNotificationCloseButtonClick || $[10] !== handleNotificationHidden || $[11] !== notifications) {
    let t6;
    if ($[13] !== handleNotificationCloseButtonClick || $[14] !== handleNotificationHidden) {
      t6 = n => <NotificationCard key={n.id} notification={n} onHidden={handleNotificationHidden} onCloseButtonClick={handleNotificationCloseButtonClick} data-testid="NotificationContainer.Notification" />;
      $[13] = handleNotificationCloseButtonClick;
      $[14] = handleNotificationHidden;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    t5 = notifications.map(t6);
    $[9] = handleNotificationCloseButtonClick;
    $[10] = handleNotificationHidden;
    $[11] = notifications;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[16] !== t5) {
    t6 = <FixedContentPortal type={FixedContentPortalType.Notification}><div className={styles.container}><div className={styles.contentWrapper}>{t5}</div></div></FixedContentPortal>;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
});